//= require personalised-config.js
//= require personalised-bundle-utils.js
//= require personalised-bundle-state.js
//= require personalised-utils.js
//= require personalised-validation.js
// CUSTOM: personalised-bundle-ui.js

(function() {
  // Ensure namespace exists
  window.personalised = window.personalised || {};
  
  // Bundle UI implementation
  const bundleUI = (function() {
  // Internal state tracking - Consolidated from event handlers
  const uiState = {
    freqChangeInProgress: false,
    removeInProgress: false,
    syncInProgress: false
  };

  // Variant lookup memoization
  let variantLookupHash = null;

  // Price calculation cache (bounded to 50 entries)
  let priceCache = new Map();

  function calculatePricesWithMemo(items, frequency) {
    const key = JSON.stringify({
      items: items.map(i => ({id: i.variantId, qty: i.quantity || 1})), 
      freq: frequency
    });
    
    if (priceCache.has(key)) {
      if (window.personalised?.debugMode) console.debug('[Price Cache] Hit for frequency', frequency);
      return priceCache.get(key);
    }
    
    // Calculate prices (existing logic)
    const totalCents = window.personalised.priceCalculator.calculateTotalPrice(
      items, 
      window.personalised.config.variantLookup
    );
    
    const totalCentsAll = window.personalised.priceCalculator.applyFrequencyMultiplier(totalCents, frequency);
    const packCount = window.personalised.priceCalculator.getPackCount(frequency);
    const beforeDiscountCents = window.personalised.priceCalculator.calculateBeforeDiscountPrice(totalCentsAll, frequency);
    const discountedTotalCents = window.personalised.priceCalculator.applyFrequencyDiscount(totalCentsAll, frequency);
    const perDayCents = window.personalised.priceCalculator.calculatePerDayPrice(discountedTotalCents, frequency);
    
    const result = {
      totalPriceDisplay: window.personalised.priceCalculator.formatPrice(discountedTotalCents),
      cycleText: `${frequency}-day subscription cycle - adjust or cancel anytime`,
      packText: `${packCount} x Monthly pack${packCount > 1 ? 's' : ''}`,
      beforeDiscountDisplay: beforeDiscountCents > discountedTotalCents ? 
        window.personalised.priceCalculator.formatPrice(beforeDiscountCents) : null,
      perDayDisplay: perDayCents > 0 ? 
        window.personalised.priceCalculator.formatPrice(perDayCents * 100) : null
    };
    
    // Cache with bounded size
    priceCache.set(key, result);
    if (priceCache.size > 50) {
      const firstKey = priceCache.keys().next().value;
      priceCache.delete(firstKey);
    }
    
    if (window.personalised?.debugMode) console.debug('[Price Cache] Miss, cached for frequency', frequency);
    return result;
  }

  // Build a robust variantId → {product, variant} lookup from productData
  function buildVariantLookup() {
    // Check if we can skip rebuild
    const currentHash = Object.keys(window.personalised.productData || {}).join(',');
    if (variantLookupHash === currentHash && window.personalised.config.variantLookup) {
      if (window.personalised?.debugMode) console.debug('[Variant Lookup] Skipped rebuild - inputs unchanged');
      return true;
    }
    
    variantLookupHash = currentHash;
    window.personalised.config.variantLookup = {};
    // Create a tracking set for all variant IDs for diagnostic purposes
    const addedVariantIds = new Set();
    
    let allProductsAvailable = typeof window.personalised.productData === 'object' && 
                              Object.keys(window.personalised.productData).length > 0;
                              
    if (allProductsAvailable) {
      Object.values(window.personalised.productData).forEach(product => {
        if (product && product.variants) {
          product.variants.forEach(variant => {
            const normalizedId = window.personalised.utils.normalizeShopifyId(variant.id);
            const lookupKey = String(normalizedId); // Consistently use String conversion for keys
            window.personalised.config.variantLookup[lookupKey] = {
              product,
              variant
            };
            
            // Diagnostic logging for variant tracking
            console.log('[Debug] Added to variantLookup:', lookupKey, variant.title);
            addedVariantIds.add(lookupKey);
            
            // Add price_cents if not present
            if (typeof variant.price_cents === 'undefined' && typeof variant.price === 'number') {
              variant.price_cents = variant.price;
            }
          });
        }
      });
      
      // Diagnostic logging - only in development
      if (window.personalised.config.debug) {
        console.debug('[buildVariantLookup] Created lookup with keys:', 
          Object.keys(window.personalised.config.variantLookup).slice(0, 5).join(', ') + 
          (Object.keys(window.personalised.config.variantLookup).length > 5 ? '...' : '')
        );
        
        // Store the list of available variant IDs for later comparison
        window.personalised.diagnostics = window.personalised.diagnostics || {};
        window.personalised.diagnostics.availableVariantIds = [...addedVariantIds];
        console.debug('[buildVariantLookup] Total variants in lookup:', addedVariantIds.size);
      }
    }
    
    return allProductsAvailable;
  }

  // UI STATE MANAGEMENT FUNCTIONS - Consolidated from event handlers
  // Set visual state for frequency change action feedback (brief visual indication)
  function setFrequencyActionFeedback(radio) {
    if (radio) {
      if (radio.classList) {
        radio.classList.add('action-feedback');
        setTimeout(() => {
          if (radio.classList) {
            radio.classList.remove('action-feedback');
          }
        }, 200);
      }
    }
  }
    // Set visual state for remove button action feedback (brief visual indication)
  function setRemoveButtonActionFeedback(button) {
    if (button) {
      if (button.classList) {
        button.classList.add('action-feedback');
        setTimeout(() => {
          if (button.classList) {
            button.classList.remove('action-feedback');
          }
        }, 200);
      }
    }
  }
  // Delegates sync state handler setup to the eventHandlers module
  function initUiStateListeners() {
    // This function is maintained for backward compatibility
    // but delegates to the new centralized event handler
    if (window.personalised.eventHandlers && typeof window.personalised.eventHandlers.initSyncStateHandlers === 'function') {
      window.personalised.eventHandlers.initSyncStateHandlers();
    }
  }
  /**
   * Renders the bundle items in the UI with optimized batching for performance.
   * Minimizes layout thrashing by creating all elements in memory before DOM insertion.
   * @returns {boolean} Success status of the rendering operation
   */
  function renderBundleItems() {
    // Reset the for-your goals cache so it re-reads localStorage each render
    _forYourCache = null;
    
    const regularListEl = document.getElementById('bundle-items-regular');
    const bulkListEl = document.getElementById('bundle-items-bulk');
    
    // Check if new structure exists
    const newStructureExists = regularListEl && bulkListEl;
    
    // Fallback to original element for backward compatibility
    const listEl = document.getElementById('bundle-items');
    
    if (!newStructureExists && !listEl) {
      console.warn('Bundle items elements not found (#bundle-items-regular, #bundle-items-bulk, or #bundle-items)');
      return false;
    }
    
    const wrapper = document.getElementById('personalised-review-wrapper');
    const emptyState = document.getElementById('personalised-review-empty-state');
    
    // CRITICAL: Ensure variant lookup is built before attempting to render
    // This provides an additional safety check in case initReviewPage didn't build it
    ensureVariantLookupBuilt();
    
    // Check if product data is available
    const allProductsAvailable = typeof window.personalised.productData === 'object' && 
                                Object.keys(window.personalised.productData).length > 0;
    
    if (!allProductsAvailable) {
      if (newStructureExists) {
        regularListEl.innerHTML = '<p>' + window.personalised.config.uiLabels.loading + '</p>';
        bulkListEl.innerHTML = '';
      } else if (listEl) {
        listEl.innerHTML = '<p>' + window.personalised.config.uiLabels.loading + '</p>';
      }
      
      if (wrapper) wrapper.style.display = '';
      if (emptyState) emptyState.style.display = 'none';
      return false;
    }
    
    // Handle empty state using validation helpers
    if (!window.personalised.validation.bundleHasItems()) {
      if (wrapper) wrapper.style.display = 'none';
      if (emptyState) emptyState.style.display = '';
      return false;
    } else {
      if (wrapper) wrapper.style.display = '';
      if (emptyState) emptyState.style.display = 'none';
    }

    // 1. PREPARE DATA: Pre-process items data before DOM operations
    if (!window.personalised.validation.validateBundleLoaded()) {
      console.warn('Bundle not loaded or empty, skipping render');
      return false;
    }
    const renderData = prepareRenderData(window.personalised.bundle.getItems());
    
    if (newStructureExists) {
      // Separate items into regular and bulk
      const regularItems = renderData.filter(item => !item.isBulkItem);
      const bulkItems = renderData.filter(item => item.isBulkItem);
      
      // 2. BUILD DOM FRAGMENTS for each section
      const regularFragment = buildDOMFragment(regularItems);
      const bulkFragment = buildDOMFragment(bulkItems);
      
      // 3. RENDER: Batch DOM updates with requestAnimationFrame
      // NOTE: Future optimization - could consolidate this RAF with updatePriceDisplay RAF
      window.requestAnimationFrame(() => {
        // Clear previous content
        regularListEl.innerHTML = '';
        bulkListEl.innerHTML = '';
        
        // Update section visibility
        const regularSection = document.getElementById('personalised-review-regular-section');
        const bulkSection = document.getElementById('personalised-review-bulk-section');
        const infoCard = regularListEl.closest('.personalised-review-info-card');
        
        if (regularItems.length > 0) {
          if (regularSection) regularSection.style.display = '';
          if (infoCard) infoCard.style.display = '';
          regularListEl.appendChild(regularFragment);
        } else {
          if (regularSection) regularSection.style.display = 'none';
          if (infoCard) infoCard.style.display = 'none';
        }
        
        if (bulkItems.length > 0) {
          if (bulkSection) bulkSection.style.display = '';
          bulkListEl.appendChild(bulkFragment);
        } else {
          if (bulkSection) bulkSection.style.display = 'none';
        }
        
        // 4. ATTACH EVENTS: Initialize handlers after DOM is updated
        initializeEventHandlers();
        
        // 5. UPDATE PRICES: Update price display after rendering
        updatePriceDisplay();
      });
    } else if (listEl) {
      // Fallback path for environments without requestAnimationFrame
      // 2. BUILD DOM: Create a document fragment to minimize DOM reflows
      const fragment = buildDOMFragment(renderData);
      
      // 3. RENDER: Batch DOM updates with requestAnimationFrame
      window.requestAnimationFrame(() => {
        // Clear previous content
        listEl.innerHTML = '';
        
        // Append all items to the DOM in a single operation
        listEl.appendChild(fragment);
        
        // 4. ATTACH EVENTS: Initialize handlers after DOM is updated
        initializeEventHandlers();
        
        // 5. UPDATE PRICES: Update price display after rendering
        updatePriceDisplay();
      });
    }
    
    return true;
  }
  
  /**
   * Prepares item data for rendering by validating and extracting required information
   * @param {Array} items - The bundle items from state
   * @returns {Array} Processed items with required render data
   */
  function prepareRenderData(items) {
    const validItems = [];
    
    if (!Array.isArray(items)) return validItems;
    
    // Diagnostic: Track all bundle item variant IDs
    const bundleVariantIds = [];
    const missingVariantIds = [];
    
    items.forEach(item => {
      // Guard against missing variant ID or invalid item data
      if (!item || !item.variantId) {
        console.warn('Invalid item in bundle state. Skipping render for this item.', item);
        return;
      }

      // Normalize variant ID using our utility function and convert to string for lookup
      // This must exactly match the format used in buildVariantLookup
      const normalizedId = window.personalised.utils.normalizeShopifyId(item.variantId);
      const currentVariantId = String(normalizedId);
      
      // Diagnostic logging for each variant ID in bundle
      console.log('[Debug] Bundle contains:', currentVariantId);
      bundleVariantIds.push(currentVariantId);
      
      // Guard against missing product data in the lookup
      const lookupKey = String(normalizedId); // Ensure string conversion for object key lookup
      const lookup = window.personalised.config.variantLookup?.[lookupKey];
      if (!lookup) {
        console.warn(`Missing productData for variant ID ${currentVariantId} (lookup key: ${lookupKey}). Skipping render for this item.`);
        missingVariantIds.push(currentVariantId);
        return;
      }

      try {
        // Extract the necessary product and variant info
        const renderItem = {
          itemData: item,
          variantId: currentVariantId,
          productId: item.productId,
          productName: lookup.product?.title || 'Unknown Product',
          variantName: lookup.variant?.title || 'Unknown Variant',
          price: lookup.variant?.formatted_price || '',
          productVariants: lookup.product?.variants || [],
          currentProductId: lookup.product?.id,
          // Add a flag for bulk items based on metafield
          isBulkItem: lookup.product?.metafields?.personalised_bulk === true,
          // Add the capsule image URL - use only the capsule_image metafield
          capsuleImage: lookup.product?.metafields?.capsule_image || null,
          // Add dosage and serves information
          dosageInfo: lookup.product?.metafields?.reco_dosage || null,
          bulkServes: lookup.product?.metafields?.bulk_serves || null,
          // Goal categories from product metafield (v2 only — v1 template doesn't output this)
          goalCategories: lookup.product?.metafields?.goal_categories || null,
          // Add flag to identify if this is the first/default variant
          isDefaultVariant: lookup.variant && lookup.product?.variants && 
                           lookup.product.variants.length > 0 && 
                           window.personalised.utils.shopifyIdsEqual(lookup.variant.id, lookup.product.variants[0].id)
        };
        
        // DEBUG: Log metafield information for this product
        console.log(`[DEBUG] Product: ${renderItem.productName}`, {
          productId: lookup.product?.id,
          metafields: lookup.product?.metafields,
          capsuleImage: renderItem.capsuleImage,
          imageTypes: {
            capsule_image: typeof lookup.product?.metafields?.capsule_image
          }
        });
        
        validItems.push(renderItem);
      } catch (err) {
        console.warn(`Error processing data for variant ID ${currentVariantId}:`, err);
      }
    });
    
    // Store diagnostic information for later analysis and log summary
    window.personalised.diagnostics = window.personalised.diagnostics || {};
    window.personalised.diagnostics.bundleVariantIds = bundleVariantIds;
    window.personalised.diagnostics.missingVariantIds = missingVariantIds;
    
    // Compare and identify missing variants
    if (missingVariantIds.length > 0) {
      console.error('[Diagnostic] Missing variant IDs:', missingVariantIds);
      
      // Check if we have previously captured available variant IDs for comparison
      if (window.personalised.diagnostics.availableVariantIds) {
        console.log('[Diagnostic] Available variant IDs in lookup:', 
                   window.personalised.diagnostics.availableVariantIds.length, 
                   'variants');
                   
        // Log the first few available IDs for context
        console.log('[Diagnostic] Sample available IDs:', 
                   window.personalised.diagnostics.availableVariantIds.slice(0, 5));
      }
      
      // Add comprehensive bundle state diagnostic
      console.log('[Diagnostic] Full bundle analysis:', {
        bundleItemCount: items.length,
        uniqueVariantIdsInBundle: [...new Set(bundleVariantIds)].length,
        missingVariantCount: missingVariantIds.length,
        missingRatio: `${missingVariantIds.length}/${bundleVariantIds.length} variants missing (${(missingVariantIds.length/bundleVariantIds.length*100).toFixed(1)}%)`
      });
    }
    
    return validItems;
  }
  
  /**
   * Creates DOM elements for all bundle items in memory before insertion
   * @param {Array} renderData - The prepared item data for rendering
   * @returns {DocumentFragment} A document fragment with all bundle item elements
   */
  function buildDOMFragment(renderData) {
    const fragment = document.createDocumentFragment();
    
    renderData.forEach(item => {
      const el = document.createElement('div');
      el.className = 'bundle-item';
      
      // Format IDs for DOM attributes
      const formattedVariantId = window.personalised.utils.formatShopifyIdForApi(item.variantId);
      const formattedProductId = window.personalised.utils.formatShopifyIdForApi(item.productId);
      
      console.debug('[buildDOMFragment] Setting formatted IDs on DOM element', {
        internalVariantId: item.variantId,
        formattedVariantId,
        internalProductId: item.productId,
        formattedProductId
      });
      
      el.dataset.variantId = formattedVariantId;
      el.dataset.productId = formattedProductId;
      
      // Build variant dropdown with safety checks
      let variantSelect = buildVariantSelectHTML(item);
      
      // Build "For your X, Y and Z goal(s)" text if applicable
      const forYourHTML = buildForYourGoalsHTML(item);

      // Get the image URL from metafields with improved error handling
      let imageUrl = '';
      let imageHtml = '';
      
      // Debug the image URL that we're working with
      console.log(`[DEBUG] Building DOM for: ${item.productName}`, {
        capsuleImage: item.capsuleImage,
        imageType: typeof item.capsuleImage
      });
      
      // Handle the capsule image data from file metafield
      // Using value | image_url: width: 400 filter in Liquid
      console.log('[FILE METAFIELD] Using CDN image URL from file metafield value:', item.capsuleImage);
      
      if (item.capsuleImage) {
        // With our fixed Liquid output, capsuleImage should always be a string URL
        // that contains the CDN image URL from image_url filter
        if (typeof item.capsuleImage === 'string') {
          // If it's a string, handle any JSON quotes (from Liquid output)
          imageUrl = item.capsuleImage.replace(/^"|"$/g, '');
        } else {
          // Log an error if we somehow still got a non-string value
          console.error(`[ERROR] Expected string URL for capsule_image but got ${typeof item.capsuleImage}`, item.capsuleImage);
        }
        
        // Create image HTML if we have a URL
        if (imageUrl) {
          const scaleClass = item.isBulkItem ? 'bundle-item-image--bulk' : 'bundle-item-image--regular';
          imageHtml = `<img src="${imageUrl}" alt="${item.productName}" class="bundle-item-image ${scaleClass}">`;
          console.log(`[DEBUG] Generated image HTML for ${item.productName} with URL: ${imageUrl}`);
        } else {
          console.log(`[DEBUG] Could not extract valid URL for ${item.productName}`);
        }
      } else {
        // If no capsule image is available, try to use a default placeholder
        console.log(`[DEBUG] No capsule image data available for ${item.productName}, using placeholder`);
        imageHtml = `<div class="bundle-item-image-placeholder" aria-label="${item.productName}"></div>`;
      }

      // First create the content for either bulk or regular items
      let additionalInfoHTML = '';
      if (item.isBulkItem) {
        // For bulk items, show bulk_serves
        additionalInfoHTML = item.bulkServes ? `<div class="bundle-item-bulk-serves">${item.bulkServes}</div>` : '';
      } else {
        // For regular items, no longer showing dosage info
        additionalInfoHTML = '';
      }

      el.innerHTML = `
        <div class="bundle-item-inner">
          ${imageHtml}
          <div class="bundle-item-content">
            <div class="bundle-item-title">${item.productName}</div>
            ${forYourHTML}
            ${additionalInfoHTML}
            ${variantSelect}
          </div>
          <div class="bundle-item-actions">
            <button class="bundle-item-remove" ${window.personalised.config.dataAttributes.removeFromPack}="${window.personalised.utils.formatShopifyIdForApi(item.variantId)}" aria-label="Remove from pack"></button>
            <div class="bundle-item-price">${item.price}</div>
          </div>
        </div>
      `;
      
      // Append to the fragment instead of directly to DOM
      fragment.appendChild(el);
    });
    
    return fragment;
  }
  
  // Cache for "for your goals" data — read once from localStorage per render cycle
  let _forYourCache = null;
  function getForYourCache() {
    if (_forYourCache) return _forYourCache;
    try {
      const goalsRaw = localStorage.getItem('vitable_goals');
      const primaryRaw = localStorage.getItem('vitable_recommended_products');
      const secondaryRaw = localStorage.getItem('vitable_recommended_secondary');
      const userGoals = goalsRaw ? JSON.parse(goalsRaw) : null;
      const primary = primaryRaw ? JSON.parse(primaryRaw) : [];
      const secondary = secondaryRaw ? JSON.parse(secondaryRaw) : [];
      const normalize = window.personalised?.utils?.normalizeShopifyId || String;
      // Build a Map of variantId -> forYourReason for fast lookup
      const recoByVariant = new Map();
      primary.concat(secondary).forEach(function(p) {
        var vid = String(normalize(p.variantId));
        if (vid) recoByVariant.set(vid, p.forYourReason || '');
      });
      // Also keep productId set for backward compat (v1 logic)
      const recoProductIds = new Set(
        primary.concat(secondary).map(function(p) { return String(normalize(p.productId)); })
      );
      _forYourCache = { userGoals: userGoals, recoProductIds: recoProductIds, recoByVariant: recoByVariant };
    } catch (e) {
      _forYourCache = { userGoals: null, recoProductIds: new Set(), recoByVariant: new Map() };
    }
    return _forYourCache;
  }
  
  /**
   * Builds the "For your X, Y and Z goal(s)" HTML for a bundle item.
   * v2: Uses forYourReason from recommendation if available.
   * v1 fallback: Cross-references user goals with product goal_categories metafield.
   * Returns empty string if conditions are not met.
   */
  function buildForYourGoalsHTML(item) {
    var cache = getForYourCache();
    // No quiz user — no "for your" text at all
    if (!cache.userGoals || cache.userGoals.length === 0) return '';

    // v2 logic: use forYourReason stored from the recommendation response
    var isV2 = document.body.classList.contains('personalised-review-v2');
    if (isV2) {
      var normalize = window.personalised?.utils?.normalizeShopifyId || String;
      var vid = String(normalize(item.variantId));
      var reason = cache.recoByVariant.get(vid);
      if (!reason) return '';
      return '<div class="bundle-item-for-your">' + reason + '</div>';
    }

    // v1 fallback: goal-matching logic
    if (cache.recoProductIds.size === 0) return '';
    var pid = String(item.productId);
    if (!cache.recoProductIds.has(pid)) return '';
    if (!Array.isArray(item.goalCategories) || item.goalCategories.length === 0) return '';
    var userGoalsLower = cache.userGoals.map(function(g) { return g.toLowerCase(); });
    var matched = item.goalCategories
      .map(function(g) { return g.toLowerCase(); })
      .filter(function(g) { return userGoalsLower.indexOf(g) !== -1; });
    if (matched.length === 0) return '';
    var text;
    if (matched.length === 1) {
      text = 'For your ' + matched[0] + ' goal';
    } else {
      text = 'For your ' + matched.slice(0, -1).join(', ') + ' and ' + matched[matched.length - 1] + ' goals';
    }
    return '<div class="bundle-item-for-your">' + text + '</div>';
  }
  
  /**
   * Builds the HTML for the variant selection dropdown or static variant display
   * @param {Object} item - The prepared item data
   * @returns {string} HTML string for variant selection
   */
  function buildVariantSelectHTML(item) {
    try {
      let variantHTML = '';
      
      if (Array.isArray(item.productVariants) && item.productVariants.length > 1) {
        console.debug('[buildVariantSelectHTML] Creating variant dropdown', {
          productId: item.productId,
          variantId: item.variantId,
          variantsCount: item.productVariants.length
        });
        
        variantHTML = `<select class="personalised-review-select" ${window.personalised.config.dataAttributes.variantSelect}="${window.personalised.utils.formatShopifyIdForApi(item.productId)}">
          ${item.productVariants.map(v => {
            if (!v || !v.id) return '';
            const isSelected = window.personalised.utils.shopifyIdsEqual(v.id, item.variantId);
            return `<option value="${window.personalised.utils.formatShopifyIdForApi(v.id)}"${isSelected ? ' selected' : ''}>${v.title || 'Unknown'}</option>`;
          }).join('')}
        </select>`;
      } else if (Array.isArray(item.productVariants) && item.productVariants.length === 1 && item.productVariants[0]) {
        variantHTML = `<span class="bundle-item-variant">${item.productVariants[0].title || 'Unknown Variant'}</span>`;
      } else {
        variantHTML = `<span class="bundle-item-variant">${item.variantName}</span>`;
      }
      
      // Check if this is a regular item (not bulk) AND the default variant to add suggested dose text
      const shouldShowSuggestedDose = !item.isBulkItem && item.isDefaultVariant;
      
      return `
        <div class="bundle-item-variant-container">
          ${variantHTML}
          ${shouldShowSuggestedDose ? '<div class="bundle-item-suggested-dose">Suggested dose</div>' : ''}
        </div>
      `;
    } catch (err) {
      console.warn('Error creating variant dropdown:', err);
      return `<span class="bundle-item-variant">Variant information unavailable</span>`;
    }
  }
  
  /**
   * Initializes all event handlers after DOM update
   * Uses centralized event handler setup from eventHandlers module
   */
  function initializeEventHandlers() {
    // After rendering all items, clean up existing handlers before re-attaching
    if (window.personalised.eventHandlers) {
      // Clean up handlers before re-attaching to prevent duplicates
      if (typeof window.personalised.eventHandlers.cleanupAllHandlers === 'function') {
        window.personalised.eventHandlers.cleanupAllHandlers();
      } else {
        // Fallback to individual cleanups for backward compatibility
        if (typeof window.personalised.eventHandlers.cleanupVariantSelectListeners === 'function') {
          window.personalised.eventHandlers.cleanupVariantSelectListeners();
        }
        if (typeof window.personalised.eventHandlers.cleanupRemoveButtonListeners === 'function') {
          window.personalised.eventHandlers.cleanupRemoveButtonListeners();
        }
      }
      
      // Re-attach event handlers
      if (typeof window.personalised.eventHandlers.initAllHandlers === 'function') {
        window.personalised.eventHandlers.initAllHandlers();
      } else {
        // Fallback to individual handlers for backward compatibility
        if (typeof window.personalised.eventHandlers.initRemoveItemHandlers === 'function') {
          window.personalised.eventHandlers.initRemoveItemHandlers();
        }
        if (typeof window.personalised.eventHandlers.initVariantSelectionHandlers === 'function') {
          window.personalised.eventHandlers.initVariantSelectionHandlers();
        }
      }
    }
  }
    
    // Update price displays in the UI
  function updatePriceDisplay() {
    // Safety check if bundle is not initialized
    if (!window.personalised.validation.validateBundleLoaded()) return;
    
    // Calculate all price values first before touching DOM
    let priceData;
    
    try {
      // Validate bundle state before calculations
      if (!window.personalised.validation.validateBundleLoaded()) {
        console.warn('Bundle not loaded, skipping price update');
        return;
      }
      
      const freq = window.personalised.validation.isValidFrequency() ? 
        parseInt(window.personalised.bundle.getFrequency(), 10) : 30;
      
      // Use memoized price calculation
      priceData = calculatePricesWithMemo(
        window.personalised.bundle.getItems(), 
        freq
      );
    } catch (err) {
      console.warn('Error calculating prices:', err);
      return;
    }
    
    // Cache DOM elements to reduce redundant queries
    const elements = {
      cycleEl: document.getElementById('subscription-cycle-text'),
      packEl: document.getElementById('monthly-pack-text'),
      priceEl: document.getElementById('bundle-total-price'),
      beforeDiscountEl: document.getElementById('bundle-before-discount-price'),
      perDayPriceEl: document.getElementById('bundle-per-day-price')
    };
    
    // Use requestAnimationFrame to batch DOM updates
    window.requestAnimationFrame(() => {
      // Update text content for main elements
      if (elements.cycleEl) elements.cycleEl.textContent = priceData.cycleText;
      if (elements.packEl) elements.packEl.textContent = priceData.packText;
      if (elements.priceEl) elements.priceEl.textContent = priceData.totalPriceDisplay;
      
      // Handle before discount price
      if (elements.beforeDiscountEl) {
        if (priceData.beforeDiscountDisplay) {
          elements.beforeDiscountEl.textContent = priceData.beforeDiscountDisplay;
          elements.beforeDiscountEl.style.display = '';
        } else {
          elements.beforeDiscountEl.textContent = '';
          elements.beforeDiscountEl.style.display = 'none';
        }
      }
      
      // Handle per day price
      if (elements.perDayPriceEl) {
        elements.perDayPriceEl.textContent = priceData.perDayDisplay || '';
      }
    });
  }
  
  // Error modal utility
  function showBundleErrorModal() {
    let modal = document.getElementById('personalised-bundle-error-modal');
    if (modal && modal.classList) {
      // Remove hidden class to show the modal
      modal.classList.remove('modal-hidden');
      
      // Add close button event listener if not already added
      const closeButton = modal.querySelector('#personalised-bundle-error-close');
      if (closeButton && !closeButton._hasClickListener) {
        const closeHandler = function() {
          if (modal && modal.classList) {
            modal.classList.add('modal-hidden');
          }
        };
        closeButton.addEventListener('click', closeHandler);
        closeButton._hasClickListener = true;

        // Track the listener for cleanup
        if (window.personalised.eventHandlers?.trackedListeners?.modalListeners) {
          window.personalised.eventHandlers.trackedListeners.modalListeners.set(closeButton, closeHandler);
        }
      }
    } else {
      console.warn('Error modal element not found in the DOM');
    }
  }

  /**
   * Shows an "Add to Pack" confirmation modal with context-aware content
   * based on current mode (edit vs new/guest) and viewport size
   * Edit mode now displays as fullscreen for all viewport widths
   */
  function showAddToPackModal() {
    // First check if modal already exists to avoid duplicate instances
    const existingModal = document.getElementById('personalised-add-to-pack-modal');
    if (existingModal && existingModal.classList.contains('active')) {
      // Modal already visible and active, no need to create a new one
      return;
    }
    
    // Clean up any existing modal that might not be active
    dismissAddToPackModal();

    try {
      // Determine current mode and viewport
      const currentMode = window.personalised?.utils?.getMode?.() || 'guest';
      const isEditMode = currentMode === window.personalised?.config?.modes?.EDIT;
      const isMobile = window.innerWidth < (window.personalised?.config?.timing?.mobileBreakpoint || 768);
      
      // Create modal element
      const modal = document.createElement('div');
      modal.className = 'personalised-add-to-pack-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Item added to pack confirmation');
      modal.id = 'personalised-add-to-pack-modal';
      
      // Apply appropriate styling based on mode
      if (isEditMode) {
        modal.classList.add('personalised-add-to-pack-modal--edit');
        modal.classList.add('personalised-add-to-pack-modal--edit-fullscreen');
      }
      
      // Create modal content
      const modalContent = document.createElement('div');
      modalContent.className = 'personalised-add-to-pack-modal__content';

      // View/Review Pack button
      const viewPackButton = document.createElement('a');
      viewPackButton.className = 'personalised-add-to-pack-modal__button';
      viewPackButton.href = window.personalised.config.routes.review;
      const buttonText = isEditMode ? 'Review Pack' : 'View Pack';
      viewPackButton.textContent = buttonText;
      if (isEditMode) {
        viewPackButton.style.fontWeight = '600';
      }

      if (isMobile) {
        // Mobile: button only — full-width sticky bar at bottom
        modal.classList.add('personalised-add-to-pack-modal--mobile-cta');
        modalContent.appendChild(viewPackButton);
      } else {
        // Desktop: tick icon + message + button
        const iconElement = document.createElement('div');
        iconElement.className = 'personalised-add-to-pack-modal__icon';
        iconElement.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"></path></svg>';

        const messageElement = document.createElement('div');
        messageElement.className = 'personalised-add-to-pack-modal__message';
        const modalText = isEditMode
          ? 'Review your pack to save changes to your subscription'
          : 'Added to Pack';
        messageElement.textContent = modalText;

        modalContent.appendChild(iconElement);
        modalContent.appendChild(messageElement);
        modalContent.appendChild(viewPackButton);

        // Desktop: dismiss when the user changes view (mode tab or filter pill)
        const viewChangeHandler = function () {
          dismissAddToPackModal();
        };
        document.addEventListener('plv2:mode-changed', viewChangeHandler);
        document.addEventListener('plv2:view-changed', viewChangeHandler);
        modal._viewChangeHandler = viewChangeHandler;
      }

      modal.appendChild(modalContent);
      
      // Add the modal to the page
      const container = document.querySelector('body');
      if (container) {
        container.appendChild(modal);
        
        // Make sure the modal is visible
        setTimeout(() => {
          modal.classList.add('active');
        }, 10);
        
        // Modal stays visible until page reload — no auto-dismiss, no Escape handler
      } else {
        console.warn('Could not find container element to append modal');
      }
    } catch (error) {
      console.warn('Error showing add to pack modal:', error);
    }
  }
  
  /**
   * Removes the "Add to Pack" modal from the DOM and cleans up event listeners
   * In edit mode, the modal will not be dismissed except by clicking the Review Pack button
   */
  function dismissAddToPackModal() {
    try {
      const modal = document.getElementById('personalised-add-to-pack-modal');
      if (modal) {
        // Check if we're in edit mode with fullscreen modal - don't dismiss
        if (modal.classList.contains('personalised-add-to-pack-modal--edit-fullscreen')) {
          // Don't dismiss edit mode fullscreen modal - user must click Review Pack
          return;
        }
        
        // Remove event listeners
        if (modal._escKeyHandler) {
          document.removeEventListener('keydown', modal._escKeyHandler);
        }
        if (modal._viewChangeHandler) {
          document.removeEventListener('plv2:mode-changed', modal._viewChangeHandler);
          document.removeEventListener('plv2:view-changed', modal._viewChangeHandler);
        }

        // Clear any auto-dismiss timeout
        if (modal._autoDismissTimeout) {
          clearTimeout(modal._autoDismissTimeout);
        }
        
        // Animate out before removing
        modal.classList.remove('active');
        
        // Remove after animation completes
        setTimeout(() => {
          if (modal.parentNode) {
            modal.parentNode.removeChild(modal);
          }
        }, 300);
      }
    } catch (error) {
      console.warn('Error dismissing add to pack modal:', error);
    }
  }

  // Initialize utility listeners
  function initPerformanceUtils() {
    // Clean up any existing listeners first
    if (window.personalised.eventHandlers?.cleanupPerformanceListeners) {
      window.personalised.eventHandlers.cleanupPerformanceListeners();
    }

    // Listen to sync events to display error messages
    const syncFailedHandler = function(data) {
      showBundleErrorModal();
    };
    window.personalised.eventBus.on('syncFailed', syncFailedHandler);

    // Track the event bus listener for cleanup
    if (window.personalised.eventHandlers?.trackedListeners?.performanceListeners) {
      window.personalised.eventHandlers.trackedListeners.performanceListeners.set('syncFailed', syncFailedHandler);
    }
    
    return true;
  }

  /**
   * Batch updates to the DOM for improved performance
   * @param {Function} updateFn - Function to execute within a requestAnimationFrame
   * @param {number} delay - Optional delay in ms before applying the update
   */
  function batchDOMUpdate(updateFn, delay = 0) {
    if (typeof updateFn !== 'function') return;
    
    if (delay > 0) {
      setTimeout(() => {
        window.requestAnimationFrame(updateFn);
      }, delay);
    } else {
      window.requestAnimationFrame(updateFn);
    }
  }

  /**
   * Ensures the variant lookup is built and up-to-date
   * This should be called whenever product data may have changed
   * @returns {boolean} True if product data was available and lookup was built
   */
  function ensureVariantLookupBuilt() {
    // Check if product data is loaded
    if (!window.personalised.productData) {
      console.warn('[ensureVariantLookupBuilt] Product data not yet available');
      return false;
    }
    
    // Check if lookup exists but might need refresh
    const currentKeys = window.personalised.config.variantLookup ? 
      Object.keys(window.personalised.config.variantLookup).length : 0;
    
    // Build or rebuild the lookup if needed
    if (currentKeys === 0) {
      console.debug('[ensureVariantLookupBuilt] Building variant lookup from scratch');
      return buildVariantLookup();
    }
    
    return true;
  }

  /**
   * Analyzes bundle state vs. lookup to identify missing variant data
   * For diagnostic purposes only - helps identify which products need to be included
   */
  function analyzeVariantMismatches() {
    // Check if we have the diagnostics namespace populated
    if (!window.personalised.diagnostics || 
        !Array.isArray(window.personalised.diagnostics.bundleVariantIds) ||
        !Array.isArray(window.personalised.diagnostics.availableVariantIds)) {
      console.error('[analyzeVariantMismatches] Diagnostic data not available. Run buildVariantLookup and prepareRenderData first.');
      return;
    }
    
    const bundleIds = window.personalised.diagnostics.bundleVariantIds;
    const availableIds = window.personalised.diagnostics.availableVariantIds;
    const missingIds = window.personalised.diagnostics.missingVariantIds || [];
    
    console.log('=== VARIANT MISMATCH ANALYSIS ===');
    console.log(`Total variants in bundle: ${bundleIds.length}`);
    console.log(`Total variants in lookup: ${availableIds.length}`);
    console.log(`Missing variants: ${missingIds.length}`);
    
    // Check raw vs normalized IDs in bundle
    const rawItems = window.personalised.bundle.getItems();
    if (rawItems && rawItems.length) {
      console.log('=== RAW vs NORMALIZED VARIANT IDs IN BUNDLE ===');
      rawItems.forEach((item, index) => {
        if (item && item.variantId) {
          const rawId = item.variantId;
          const normalizedId = window.personalised.utils.normalizeShopifyId(rawId);
          const stringId = String(normalizedId);
          const isInLookup = window.personalised.config.variantLookup && 
                             window.personalised.config.variantLookup[stringId];
          
          console.log(`Item ${index}: Raw ID=${rawId} → Normalized=${normalizedId} → String=${stringId} → In lookup: ${isInLookup ? 'YES' : 'NO'}`);
        }
      });
    }
    
    if (missingIds.length > 0) {
      console.log('Missing variant IDs:', missingIds);
      
      // Check which products might be missing from productData
      const bundleProductIds = new Set();
      window.personalised.bundle.getItems().forEach(item => {
        if (item && item.productId) {
          bundleProductIds.add(String(window.personalised.utils.normalizeShopifyId(item.productId)));
        }
      });
      
      // Check which product IDs exist in the lookup
      const availableProductIds = new Set();
      if (window.personalised.productData) {
        Object.values(window.personalised.productData).forEach(product => {
          if (product && product.id) {
            availableProductIds.add(String(window.personalised.utils.normalizeShopifyId(product.id)));
          }
        });
      }
      
      // Find missing product IDs
      const missingProducts = [...bundleProductIds].filter(id => !availableProductIds.has(id));
      
      if (missingProducts.length > 0) {
        console.log('=== MISSING PRODUCTS ===');
        console.log(`Found ${missingProducts.length} product IDs in bundle that don't exist in productData:`);
        console.log(missingProducts);
        console.log('RECOMMENDATION: These products need to be added to productData');
      } else {
        console.log('=== VARIANT LEVEL ISSUE ===');
        console.log('All product IDs from bundle exist in productData, but specific variants are missing.');
        
        // Build a map of variants by product for detailed analysis
        const bundleVariantsByProduct = {};
        
        rawItems.forEach(item => {
          if (item && item.productId && item.variantId) {
            const productId = String(window.personalised.utils.normalizeShopifyId(item.productId));
            const variantId = String(window.personalised.utils.normalizeShopifyId(item.variantId));
            
            bundleVariantsByProduct[productId] = bundleVariantsByProduct[productId] || [];
            bundleVariantsByProduct[productId].push(variantId);
          }
        });
        
        // Compare with available variants for each product
        const missingByProduct = {};
        
        Object.entries(bundleVariantsByProduct).forEach(([productId, variants]) => {
          const product = Object.values(window.personalised.productData).find(p => 
            String(window.personalised.utils.normalizeShopifyId(p.id)) === productId);
            
          if (product) {
            // Build set of available variant IDs for this product
            const availableVariants = new Set();
            if (product.variants) {
              product.variants.forEach(v => {
                availableVariants.add(String(window.personalised.utils.normalizeShopifyId(v.id)));
              });
            }
            
            // Find missing variants
            const missingVariants = variants.filter(id => !availableVariants.has(id));
            if (missingVariants.length > 0) {
              missingByProduct[productId] = {
                productTitle: product.title || 'Unknown Product',
                missingVariants,
                totalVariantsInBundle: variants.length,
                totalVariantsAvailable: availableVariants.size
              };
            }
          }
        });
        
        // Report missing variants by product
        if (Object.keys(missingByProduct).length > 0) {
          console.log('=== MISSING VARIANTS BY PRODUCT ===');
          Object.entries(missingByProduct).forEach(([productId, info]) => {
            console.log(`Product "${info.productTitle}" (${productId}):`);
            console.log(`  - Missing variants: ${info.missingVariants.join(', ')}`);
            console.log(`  - ${info.totalVariantsAvailable} variants available, ${info.totalVariantsInBundle} variants in bundle`);
          });
          console.log('RECOMMENDATION: Update productData to include all missing variants');
        }
      }
    }
  }

  /**
   * Runs all diagnostics checks automatically
   * Attaches a one-time listener to bundle state load event
   */
  function initDiagnostics() {
    // Only initialize if debug mode is enabled
    if (!window.personalised.config.debug) return;
    
    console.log('[Diagnostics] Initializing bundle state vs product data diagnostic...');
    
    // Create diagnostics namespace if not exists
    window.personalised.diagnostics = window.personalised.diagnostics || {};
    
    // Attach a one-time listener to run diagnostics after bundle state is loaded
    const diagnosticHandler = function() {
      console.log('[Diagnostics] Bundle state loaded, scheduling variant analysis...');
      
      // Schedule analysis for after render cycle completes
      setTimeout(() => {
        if (typeof analyzeVariantMismatches === 'function') {
          console.log('[Diagnostics] Running variant mismatch analysis...');
          analyzeVariantMismatches();
        }
      }, 1000);
      
      // Remove this one-time listener
      window.personalised.eventBus.off('bundleStateLoaded', diagnosticHandler);
    };
    
    // Attach the listener
    window.personalised.eventBus.on('bundleStateLoaded', diagnosticHandler);
    console.log('[Diagnostics] Diagnostic listener attached to bundleStateLoaded event');
    
    return true;
  }

  // Temporary state to store the variant ID for removal confirmation
  let pendingRemovalVariantId = null;

  // Show the last item removal confirmation modal
  function showLastItemConfirmationModal(variantId) {
    // Store the variant ID for later use if confirmed
    pendingRemovalVariantId = variantId;
    
    let modal = document.getElementById('personalised-last-item-modal');
    if (modal && modal.classList) {
      // Remove hidden class to show the modal
      modal.classList.remove('modal-hidden');
      
      // Add button event listeners if not already added
      const confirmButton = modal.querySelector('#personalised-last-item-confirm');
      const cancelButton = modal.querySelector('#personalised-last-item-cancel');
      
      if (confirmButton && !confirmButton._hasClickListener) {
        const confirmHandler = function() {
          // Hide the modal
          if (modal && modal.classList) {
            modal.classList.add('modal-hidden');
          }
          
          // Proceed with removal if we have a valid variant ID
          if (pendingRemovalVariantId) {
            // Execute the actual removal logic
            confirmLastItemRemoval(pendingRemovalVariantId);
            // Clear the pending ID
            pendingRemovalVariantId = null;
          }
        };
        confirmButton.addEventListener('click', confirmHandler);
        confirmButton._hasClickListener = true;

        // Track the listener for cleanup
        if (window.personalised.eventHandlers?.trackedListeners?.modalListeners) {
          window.personalised.eventHandlers.trackedListeners.modalListeners.set(confirmButton, confirmHandler);
        }
      }
      
      if (cancelButton && !cancelButton._hasClickListener) {
        const cancelHandler = function() {
          // Just hide the modal without taking action
          if (modal && modal.classList) {
            modal.classList.add('modal-hidden');
          }
          // Clear the pending ID
          pendingRemovalVariantId = null;
        };
        cancelButton.addEventListener('click', cancelHandler);
        cancelButton._hasClickListener = true;

        // Track the listener for cleanup
        if (window.personalised.eventHandlers?.trackedListeners?.modalListeners) {
          window.personalised.eventHandlers.trackedListeners.modalListeners.set(cancelButton, cancelHandler);
        }
      }
    } else {
      console.warn('Last item confirmation modal element not found in the DOM');
      // Fallback: proceed with removal without confirmation
      confirmLastItemRemoval(variantId);
    }
  }

  // Process the confirmed removal of the last item
  function confirmLastItemRemoval(variantId) {
    try {
      // Remove item using bundle API
      window.personalised.bundle.removeItemByVariantId(variantId);
      // PR-2.4: mark state modified so the review-page timestamp skip does not suppress
      // a defensive sync if this remove sync fails before completing.
      window.personalised.storageManager?.markBundleModified();
      
      // Update UI immediately
      window.personalised.bundleUI.renderBundleItems();
      
      // Schedule debounced cart sync
      const message = '✅ Items removed from your personalised pack';
      
      // Skip cart sync in edit mode
      if (window.personalised.utils && window.personalised.utils.getMode() === window.personalised.config.modes.EDIT) return;
      
      if (window.personalised.utils && typeof window.personalised.utils.debouncedRefreshCartFromState === 'function') {
        window.personalised.utils.debouncedRefreshCartFromState(message);
      }
    } catch (err) {
      window.personalised.bundleUI.showBundleErrorModal();
      console.error('Error removing last item from bundle:', err);
    }
  }

  /**
   * Waits for UI to be visually settled after rendering
   * Tracks RAF completion and image loading with timeouts
   * @returns {Promise<void>} Resolves when UI is visually ready
   */
  function whenUiSettled() {
    return new Promise((resolve) => {
      let pendingTasks = 0;
      let resolved = false;
      
      const tryResolve = () => {
        if (!resolved && pendingTasks === 0) {
          resolved = true;
          if (window.personalised?.debugMode) console.debug('[UI] whenUiSettled() resolved');
          resolve();
        }
      };
      
      // Wait for next RAF that handles DOM/handlers/prices
      pendingTasks++;
      window.requestAnimationFrame(() => {
        if (window.personalised?.debugMode) console.debug('[UI] RAF batch completed');
        pendingTasks--;
        tryResolve();
      });
      
      // Track first 3 images max
      const images = document.querySelectorAll('.bundle-item-image');
      const imagesToTrack = Math.min(3, images.length);
      
      if (imagesToTrack > 0) {
        if (window.personalised?.debugMode) console.debug('[UI] Tracking', imagesToTrack, 'images');
        pendingTasks += imagesToTrack;
        
        Array.from(images).slice(0, imagesToTrack).forEach((img, index) => {
          const onComplete = () => {
            if (window.personalised?.debugMode) console.debug('[UI] Image', index, 'loaded/errored');
            pendingTasks--;
            tryResolve();
          };
          
          if (img.complete) {
            onComplete();
          } else {
            img.addEventListener('load', onComplete, { once: true });
            img.addEventListener('error', onComplete, { once: true });
            // Per-image timeout
            setTimeout(onComplete, 500);
          }
        });
      }
      
      // Global timeout cap
      setTimeout(() => {
        if (!resolved) {
          if (window.personalised?.debugMode) console.debug('[UI] whenUiSettled() timed out');
          resolved = true;
          resolve();
        }
      }, 2000);
    });
  }

  // Public API
  return {
    buildVariantLookup,
    ensureVariantLookupBuilt,
    renderBundleItems,
    whenUiSettled,
    updatePriceDisplay,
    showBundleErrorModal,
    showLastItemConfirmationModal,
    confirmLastItemRemoval,
    showAddToPackModal,
    dismissAddToPackModal,
    initPerformanceUtils,
    // New modular rendering functions
    prepareRenderData,
    buildDOMFragment,
    buildVariantSelectHTML,
    initializeEventHandlers,
    batchDOMUpdate,
    // Diagnostic helpers
    analyzeVariantMismatches,
    initDiagnostics,
    // Expose UI state management functions
    setFrequencyActionFeedback,
    setRemoveButtonActionFeedback,
    initUiStateListeners,
    // Expose UI state for external use
    uiState
  };
  })();
    // Assign to single namespace
  window.personalised.bundleUI = bundleUI;
})(window);
